<script setup>
import {usePortalContentAndDesignStore} from "../../../../../../stores/partners/portalContentAndDesignStore";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const layoutPadding = computed(() => {
    if (portalContentAndDesignStore.portalLayoutSettings.public_page_content_layout === 'one') return '';
    return 'px-8 lg:px-14';
});

import {computed, provide} from "vue";
import LandingResourceContentBlock from "../../../includes/resources/landing-page/LandingResourceContentBlock.vue";
import LandingResourceImage from "../../../includes/resources/landing-page/LandingResourceImage.vue";
import LandingResourceText from "../../../includes/resources/landing-page/LandingResourceText.vue";
import LandingResourceCta from "../../../includes/resources/landing-page/LandingResourceCta.vue";
import LandingResourceFaq from "../../../includes/resources/landing-page/LandingResourceFaq.vue";
import LandingResourceLink from "../../../includes/resources/landing-page/LandingResourceLink.vue";
import LandingResourceAvailableRewards from "../../../includes/resources/landing-page/LandingResourceAvailableRewards.vue";
import LandingResourceEarningsCalculator from "../../../includes/resources/landing-page/LandingResourceEarningsCalculator.vue";
import LandingResourceDivider from "../../../includes/resources/landing-page/LandingResourceDivider.vue";
import LandingResourceHowItWorks from "../../../includes/resources/landing-page/LandingResourceHowItWorks.vue";
import LandingResourceEmbed from "../../../includes/resources/landing-page/LandingResourceEmbed.vue";
import LandingResourceCustomBlock from "../../../includes/resources/landing-page/LandingResourceCustomBlock.vue";

const getComponentForResource = (resource) => {
    // available_rewards doesn't require contents to be present
    if (resource.type === 'available_rewards') {
        return LandingResourceAvailableRewards;
    }
    
    // earnings_calculator doesn't require contents to be present
    if (resource.type === 'earnings_calculator') {
        return LandingResourceEarningsCalculator;
    }

    // divider doesn't require contents
    if (resource.type === 'divider') {
        return LandingResourceDivider;
    }

    // how_it_works doesn't require contents (pre-filled)
    if (resource.type === 'how_it_works') {
        return LandingResourceHowItWorks;
    }

    // embed doesn't require contents
    if (resource.type === 'embed') {
        return LandingResourceEmbed;
    }

    // custom_block uses items instead of contents
    if (resource.type === 'custom_block') {
        return LandingResourceCustomBlock;
    }
    
    if (!resource || !resource.contents || !resource.contents.length) return null;
    switch (resource.type) {
        case 'content_block':
            return LandingResourceContentBlock;
        case 'image':
            return LandingResourceImage;
        case 'text':
            return LandingResourceText;
        case 'cta':
            return LandingResourceCta;
        case 'faq':
            return LandingResourceFaq;
        case 'link':
            return LandingResourceLink;
        default:
            return null;
    }
};

provide('fileUrls', {
    upload: portalContentAndDesignStore.getFileResourcesUploadRoute,
    delete: portalContentAndDesignStore.getFileResourcesDeleteRoute,
});
</script>

<template>
    <div
        v-if="portalContentAndDesignStore.getLandingPageSettings?.landing_page_resources?.resources && portalContentAndDesignStore.getLandingPageSettings.landing_page_resources.resources.length"
        :class="[
              'pt-8 lg:pt-12 pb-8 lg:pb-20 space-y-12 border-t',
              layoutPadding,
              portalContentAndDesignStore.getPageContentTextColorClass
            ]"
    >
        <component
            v-for="(resource, index) in portalContentAndDesignStore.getLandingPageSettings.landing_page_resources.resources"
            :key="index"
            :is="getComponentForResource(resource)"
            :resource="resource"
        />
    </div>
</template>

<style scoped>

</style>
